import { Link, useLocation, useNavigate, } from "react-router-dom";
import { Button } from "reactstrap";
import { SwitchToggle } from "../../../Components/TableHelper";
import { useFormik } from "formik";
import axiosInstance from "../../../axiosInterceptor";
import { toast } from "react-toastify";
import Breadcrumb from "../../../Components/Breadcrumb";
import { useState } from "react";

const AddClientType = () => {
    const navigator = useNavigate();
    const location = useLocation();
    const editData = location.state;
    const editingId = editData?._id;

    const [loading, setLoading] = useState(false);
    const initialValues = {
        sortOrder: editData?.sortOrder || 1,
        name: editData?.name || "",
        title: editData?.title || "",
        isActive:
            typeof editData?.isActive === "boolean"
                ? editData.isActive
                : true,
    };

    const {
        values,
        errors,
        touched,
        handleChange,
        handleSubmit,
        setFieldValue,
    } = useFormik({
        initialValues,
        onSubmit: async (values) => {
            setLoading(true);
            try {
                const payload = {
                    sortOrder: Number(values.sortOrder),
                    name: values.name.trim(),
                    title: values.title.trim(),
                    isActive: values.isActive,
                };

                let response;

                if (editingId) {
                    response = await axiosInstance.put(
                        `/clienttype/updatetype/${editingId}`,
                        payload
                    );
                }
                else {
                    response = await axiosInstance.post(
                        "/clienttype/createtype",
                        payload
                    );
                }

                if (
                    response?.status === 200 ||
                    response?.status === 201
                ) {
                    toast.success(response?.data?.message);
                    navigator("/client-type");
                }
            } catch (error) {
                toast.error(
                    error?.response?.data?.message
                );
            } finally {
                setLoading(false);
            }
        },
    });

    const breadcrumbdata = [
        {
            label: "Home",
            path: "/dashboard",
        },
        {
            label: "Client Types",
            path: "/client-type",
        },
        {
            label: editingId ? "Update" : "Add",
            path: "*",
        },
    ];

    return (
        <>
            <div className="content-wrapper">
                <div className="page-header mb-3">
                    <h3 className="custom-page-title">
                        {editingId ? "Update" : "Add"} Client Type
                    </h3>
                    <Breadcrumb items={breadcrumbdata} />
                </div>

                <div className="col-md-12 grid-margin stretch-card p-0">
                    <div className="card m-0">
                        <div className="card-body">
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-sm-6">
                                        <div className="form-group">
                                            <label
                                                htmlFor="clientType-sortOrder"
                                                className="col-form-label"
                                            >
                                                Sort Order
                                            </label>

                                            <input
                                                type="number"
                                                className="border border-dark form-control"
                                                id="clientType-sortOrder"
                                                name="sortOrder"
                                                placeholder="Enter Sort Order"
                                                min={1}
                                                value={values.sortOrder}
                                                onChange={handleChange}
                                            />

                                            {touched.sortOrder &&
                                                errors.sortOrder && (
                                                    <small className="text-danger">
                                                        {errors.sortOrder}
                                                    </small>
                                                )}
                                        </div>
                                    </div>

                                    <div className="col-sm-6">
                                        <div className="form-group">

                                            <label
                                                htmlFor="clientType-name"
                                                className="col-form-label"
                                            >
                                                Name
                                            </label>
                                            <input
                                                type="text"
                                                className="border border-dark form-control"
                                                id="clientType-name"
                                                name="name"
                                                placeholder="Enter Client Type Name"
                                                value={values.name}
                                                onChange={handleChange}
                                            />
                                            {touched.name && errors.name && (
                                                <small className="text-danger">
                                                    {errors.name}
                                                </small>
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-sm-6 mt-3">
                                        <div className="form-group">
                                            <label
                                                htmlFor="clientType-title"
                                                className="col-form-label"
                                            >
                                                Title
                                            </label>
                                            <input
                                                type="text"
                                                className="border border-dark form-control"
                                                id="clientType-title"
                                                name="title"
                                                placeholder="Enter Client Type Title"
                                                value={values.title}
                                                onChange={handleChange}
                                            />
                                            {touched.title && errors.title && (
                                                <small className="text-danger">
                                                    {errors.title}
                                                </small>
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-md-12 mt-4">
                                        <SwitchToggle
                                            checked={values.isActive}
                                            onChange={(val) =>
                                                setFieldValue("isActive", val)
                                            }
                                        />
                                    </div>
                                </div>

                                <div className="text-center mt-4">
                                    <Button
                                        type="submit"
                                        color="primary"
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <span className="d-inline-flex align-items-center gap-2">
                                                <span
                                                    className="spinner-border spinner-border-sm"
                                                    role="status"
                                                    aria-hidden="true"
                                                ></span>
                                                Processing...
                                            </span>
                                        ) : (
                                            "Save"
                                        )}
                                    </Button>

                                    <Link to="/client-type">
                                        <Button color="danger mx-2">
                                            Cancel
                                        </Button>
                                    </Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddClientType;